import { RequestId } from '../../components/utilities/Table/generalColumns/RequestId';
import { OfficeRequest } from '../../components/utilities/Table/generalColumns/RegionalRequest';
import { ClientIdentification } from '../../components/utilities/Table/generalColumns/ClientIdentification';
import { ExecutiveWithTooltip } from '../../components/utilities/Table/generalColumns/ExecutiveWithTooltip';
import { StatusWithTooltip } from '../../components/utilities/Table/generalColumns/StatusWithTooltip';
import { CausalRequest } from '../../components/utilities/Table/generalColumns/CausalRequest';
import { ConcesionaryRequest } from '../../components/utilities/Table/generalColumns/ConsecionaryRequest';
import { DefineDate } from '../../components/utilities/Table/generalColumns/DefineDate';
import {
    replaceRequestId,
    RequestDays,
} from '../../components/utilities/Table/generalColumns/RequestIdWithWarning';

const commonColumns = [
    RequestId,
    {
        Header: 'Fecha Creación',
        accessor: 'gestionsolicitud.fecha_creacion',
    },
    ConcesionaryRequest,
    {
        Header: 'Producto',
        accessor: 'subproducto.label',
    },
    OfficeRequest,
    ClientIdentification,
    {
        Header: 'Cliente',
        accessor: 'persona.full_name',
        typeId: 'HeaderClient',
    },
    ExecutiveWithTooltip,
    StatusWithTooltip,
];

const requestsListStatus = [
    {
        id: 'aliado',
        label: 'ALIADO',
        status: '5',
        responsable: null,
        offices: false,
        columns: (() => {
            const cols = [...commonColumns];
            cols.splice(1, 0, RequestDays('gestionsolicitud.fecha_creacion'));
            return cols;
        })(),
        registrationLimit: 5, // limit for registration in list credits
    },
    {
        id: 'en_proceso',
        label: 'EN PROCESO',
        status: '10,20,30,40',
        responsable: null,
        offices: true,
        columns: (() => {
            const cols = [...commonColumns];
            cols.splice(1, 0, RequestDays('gestionsolicitud.fecha_creacion'));
            return cols;
        })(),
        registrationLimit: 5, // limit for registration in list credits
    },
    {
        id: 'aprobadas',
        label: 'APROBADAS',
        status: '50,60',
        responsable: null,
        offices: true,
        columns: replaceRequestId(
            (() => {
                const cols = [...commonColumns];
                cols[1] = DefineDate('fecha_comite', 'Fecha Comité');
                cols.splice(
                    1,
                    0,
                    RequestDays('gestionsolicitud.fecha_creacion')
                );
                return cols;
            })()
        ),
        registrationLimit: 5, // limit for registration in list credits
    },
    {
        id: 'desembolsadas',
        label: 'DESEMBOLSADAS',
        status: '90',
        responsable: null,
        offices: true,
        columns: replaceRequestId(
            (() => {
                const cols = [...commonColumns];
                cols[1] = DefineDate('fecha_desembolso', 'Fecha Desembolso');
                return cols;
            })()
        ),
        registrationLimit: 5, // limit for registration in list credits
    },
    {
        id: 'desistidas',
        label: 'DESISTIDAS',
        status: '80',
        responsable: null,
        offices: true,
        columns: replaceRequestId(
            (() => {
                const cols = [...commonColumns];
                cols[1] = DefineDate(
                    'fecha_desistimiento',
                    'Fecha Desistimiento'
                );
                cols.splice(10, 0, CausalRequest);
                return cols;
            })()
        ),
        registrationLimit: 5, // limit for registration in list credits
    },

    {
        id: 'rechazadas',
        label: 'RECHAZADAS',
        status: '70',
        responsable: null,
        offices: true,
        columns: replaceRequestId(
            (() => {
                const cols = [...commonColumns];
                cols[1] = DefineDate('fecha_rechazo', 'Fecha Rechazo');
                cols.splice(10, 0, CausalRequest);
                return cols;
            })()
        ),
        registrationLimit: 5, // limit for registration in list credits
    },
];

export default requestsListStatus;
